'use client'

import './FieldDateTime.scss'

import React, { forwardRef, useState } from 'react'

import { IBookingTime } from '@/src/entities/event/api/interfaces'
import { formatDateString, formatTimeString } from '@/src/shared/lib'
import { FieldSelect } from '@/src/shared/ui/FieldSelect'
import { IOption } from '@/src/shared/ui/FieldSelect/FieldSelect'

type Props = {
  dates: IBookingTime
  errors?: string[]
  value: string
  placeholderDate?: string
  placeholderTime?: string
  onChange: (value: string) => void
}

type Ref = HTMLInputElement

const FieldDateTime = forwardRef<Ref, Props>(
  ({ dates, placeholderDate, placeholderTime, onChange, value, errors = [] }, ref) => {
    const [selectedDate, setDelectedDate] = useState<IOption>({ id: undefined, value: null })

    const handleDateChange = (option: IOption) => {
      setDelectedDate(option)
      onChange('')
    }

    const handleTimeChange = (option: IOption) => {
      onChange(option.id as string)
    }

    const parsedErrors = (() => {
      if (errors === null || errors.length === 0) return null

      return errors.join(', ')
    })()

    const optionsDates =
      Object.keys(dates ?? {})?.map((date) => {
        return {
          id: date,
          value: formatDateString(date),
        }
      }) ?? []

    const times =
      dates?.[`${selectedDate.id}`]?.map((time, key) => {
        const formattedStartTime = formatTimeString(time)
        const finishTime = dates?.[`${selectedDate.id}`][key + 1]

        const formattedfinishTime = finishTime ? formatTimeString(finishTime) : null

        return {
          id: time,
          value: `${formattedStartTime} - ${formattedfinishTime}`,
        }
      }) ?? []

    const optionsTimes = times?.slice(0, times.length - 1)
    const selectedTime = value ? { id: value, value: value } : { id: undefined, value: null }

    return (
      <div className="field-date-time" ref={ref}>
        <div className="field-date-time__body">
          <div className="field-date-time__cell">
            <FieldSelect
              placeholder={placeholderDate}
              onChange={handleDateChange}
              value={selectedDate}
              options={optionsDates}
            />
          </div>

          <div className="field-date-time__cell">
            <FieldSelect
              placeholder={placeholderTime}
              onChange={handleTimeChange}
              value={selectedTime}
              options={optionsTimes}
            />
          </div>
        </div>

        {parsedErrors && <div className="field-date-time__errors">{parsedErrors}</div>}
      </div>
    )
  },
)

FieldDateTime.displayName = 'FieldDateTime'

export default FieldDateTime
